// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { IconClose } from 'components/atoms/icons/IconClose';
import { Modal } from 'components/atoms/Modal';
import CreateUpdateTemporaryStorageInputForm, {
  CreateUpdateTemporaryStorageFormInputType,
} from 'components/molecules/CreateUpdateTemporaryStorageInputForm';
import { Suggestion } from 'components/molecules/InputDataListField';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CreateUpdateTemporaryStorageModal.module.scss';
import { TemporaryStorage } from '../TemporaryStorageManagement';
interface Props {
  onClose: () => void;
  type: CreateUpdateTemporaryStorageFormInputType;
  itemId?: string;
  onSubmit: () => void;
  detailTemporaryStorage?: TemporaryStorage;
  dataSuggestions: Suggestion[];
  colorIndex: number;
}

const CreateUpdateTemporaryStorageModal: React.FC<Props> = ({
  onClose,
  type,
  onSubmit,
  detailTemporaryStorage,
  dataSuggestions,
  colorIndex,
}) => {
  const { t } = useTranslation();

  const handleSubmit = () => {
    onSubmit();
    onClose();
  };
  return (
    <div className={styles.createTemporaryStorageModal}>
      <Modal>
        <div className={styles.modalContent}>
          <div className={styles.customTitle}>
            <p className={styles.descriptionTitle}>
              {type === CreateUpdateTemporaryStorageFormInputType.add
                ? t('modal_temporary_storage.add_title')
                : t('modal_temporary_storage.edit_title')}
            </p>
            <div className={styles.top}>
              <IconClose onClick={onClose} />
            </div>
          </div>
          <CreateUpdateTemporaryStorageInputForm
            dataSuggestions={dataSuggestions}
            detailTemporaryStorage={detailTemporaryStorage}
            onSubmit={handleSubmit}
            type={type}
            colorIndex={colorIndex}
          />
        </div>
      </Modal>
    </div>
  );
};

export default CreateUpdateTemporaryStorageModal;
